/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as React from "react";

import cx from "classnames";
import BtnGrid from "@tunnel-components/@sharded/widgets/forms/input/button/custom/component";
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";
import BoxGrid from "@tunnel-components/@sharded/widgets/box/custom/component";
import * as i18next from "i18next"; // traduction
/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    bauchecked,
    swchecked,
    slowroadchecked,
    quickroadchecked,
    onSubmit,
    parkingchecked,
    disabled,
    mileagestart,
    name,
    type,
    length,
    parking,
    quickroad,
    sectionsettings,
    mileageend,
    slowroad,
    slowroadmileagestart,
    swmileagestart,
    swmileageend,
    sw,
    parkingmileagestart,
    bau,
    baumileagestart,
    baumileageend,
    onChange,
    parkingmileageend,
    slowroadmileageend,
    quickroadmileagestart,
    quickroadmileageend,
  } = props;

  // const error = !bauchecked || !swchecked || !slowroadchecked || !quickroadchecked || !parkingchecked ;
  const User = Utils.createdUserRoles();
  const authorization = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.SYSTEMUPDATEDTUBES,
  ]);

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <div
      key={"section"}
      className="settings-parameters"
      style={{ width: "99%" }}
    >
      <li className="settings ">
        <BoxGrid title="CARACTÉRISTIQUES" classNames="boderShadow">
          <div className="settings-field">
            <label>{i18next.t("nom")} : </label>
            <input
              type="text"
              name="name"
              className="settings-name"
              autoComplete="off"
              value={name}
              disabled={true}
            />
          </div>
          <div className="settings-field">
            <label>{i18next.t("type")} : </label>
            <input
              autoComplete="off"
              type="text"
              name="type"
              className={cx("settings-input")}
              value={type}
              disabled={true}
            />
          </div>
          <div className="settings-field">
            <label>{i18next.t("couleur")} : </label>
            {props.sectionsettings && (
              <input
                autoComplete="off"
                type="text"
                name="color"
                className={cx("settings-input")}
                style={{
                  backgroundColor:
                    sectionsettings.color && sectionsettings.color.rgbString,
                }}
                disabled={true}
              />
            )}
          </div>
          <div className="settings-field">
            <label>{i18next.t("longueur")} : </label>
            <input
              autoComplete="off"
              type="text"
              name="length"
              className={cx("settings-input")}
              value={length}
              disabled={true}
            />
          </div>
          <div className="settings-field">
            <label>{i18next.t("pk debut")} : </label>
            <input
              autoComplete="off"
              type="text"
              name="mileagestart"
              className={cx("settings-input")}
              value={mileagestart}
              disabled={true}
            />
          </div>
          <div className="settings-field">
            <label>{i18next.t("pk fin")} : </label>
            <input
              autoComplete="off"
              type="text"
              name="mileageend"
              className={cx("settings-input")}
              value={mileageend}
              disabled={true}
            />
          </div>
        </BoxGrid>
      </li>

      <li className="settings">
        <BoxGrid title="SENS DE CIRCULATION" classNames="boderShadow">
          <div className="display-content">
            {(!bauchecked ||
              !swchecked ||
              !slowroadchecked ||
              !quickroadchecked ||
              !parkingchecked) && (
              <div className="error-settings">
                <span>
                  {" "}
                  {i18next.t(
                    "veuillez sélectionner des points kilométriques de départ (De) et d’arrivée (Vers) différents"
                  )}
                </span>
              </div>
            )}
            <div
              className={
                bau
                  ? bauchecked
                    ? "settings-field"
                    : "settings-field error"
                  : "settings-field zone-disabled"
              }
            >
              <label>{i18next.t("bau")}</label>
              <span className="settings-pk-from">{i18next.t("de")}</span>
              <select
                className={cx("settings-input", {
                  selectIsdesabled: disabled || !bau,
                })}
                name="baumileagestart"
                value={baumileagestart}
                onChange={onChange}
                disabled={disabled || !bau}
              >
                <option value={mileagestart}>{mileagestart}</option>
                <option value={mileageend}>{mileageend}</option>
              </select>
              <span className="settings-pk-to">{i18next.t("vers")}</span>
              <select
                className={cx("settings-input", {
                  selectIsdesabled: disabled || !bau,
                })}
                name="baumileageend"
                value={baumileageend}
                onChange={onChange}
                disabled={disabled || !bau}
              >
                <option value={mileageend}>{mileageend}</option>
                <option value={mileagestart}>{mileagestart}</option>
              </select>
            </div>
            <div
              className={
                sw
                  ? swchecked
                    ? "settings-field"
                    : "settings-field error"
                  : "settings-field zone-disabled"
              }
            >
              <label>{i18next.t("trottoir")}</label>
              <span className="settings-pk-from">{i18next.t("de")}</span>
              <select
                className={cx("settings-input", {
                  selectIsdesabled: disabled || !sw,
                })}
                name="swmileagestart"
                value={swmileagestart}
                onChange={onChange}
                disabled={disabled || !sw}
              >
                <option value={mileagestart}>{mileagestart}</option>
                <option value={mileageend}>{mileageend}</option>
              </select>
              <span className="settings-pk-to">{i18next.t("vers")}</span>
              <select
                className={cx("settings-input", {
                  selectIsdesabled: disabled || !sw,
                })}
                name="swmileageend"
                value={swmileageend}
                onChange={onChange}
                disabled={disabled || !sw}
              >
                <option value={mileageend}>{mileageend}</option>
                <option value={mileagestart}>{mileagestart}</option>
              </select>
            </div>
            <div
              className={
                slowroad
                  ? slowroadchecked
                    ? "settings-field"
                    : "settings-field error"
                  : "settings-field zone-disabled"
              }
            >
              <label>{i18next.t("voie lente")} </label>
              <span className="settings-pk-from">{i18next.t("de")}</span>
              <select
                className={cx("settings-input", {
                  selectIsdesabled: disabled || !slowroad,
                })}
                name="slowroadmileagestart"
                value={slowroadmileagestart}
                onChange={onChange}
                disabled={disabled || !slowroad}
              >
                <option value={mileagestart}>{mileagestart}</option>
                <option value={mileageend}>{mileageend}</option>
              </select>
              <span className="settings-pk-to">{i18next.t("vers")}</span>
              <select
                className={cx("settings-input", {
                  selectIsdesabled: disabled || !slowroad,
                })}
                name="slowroadmileageend"
                value={slowroadmileageend}
                onChange={onChange}
                disabled={disabled || !slowroad}
              >
                <option value={mileageend}>{mileageend}</option>
                <option value={mileagestart}>{mileagestart}</option>
              </select>
            </div>
            <div
              className={
                quickroad
                  ? quickroadchecked
                    ? "settings-field"
                    : "settings-field error"
                  : "settings-field zone-disabled"
              }
            >
              <label> {i18next.t("voie rapide")}</label>
              <span className="settings-pk-from">{i18next.t("de")}</span>
              <select
                className={cx("settings-input", {
                  selectIsdesabled: disabled || !quickroad,
                })}
                name="quickroadmileagestart"
                value={quickroadmileagestart}
                onChange={onChange}
                disabled={disabled || !quickroad}
              >
                <option value={mileagestart}>{mileagestart}</option>
                <option value={mileageend}>{mileageend}</option>
              </select>
              <span className="settings-pk-to">{i18next.t("vers")}</span>
              <select
                className={cx("settings-input", {
                  selectIsdesabled: disabled || !quickroad,
                })}
                name="quickroadmileageend"
                value={quickroadmileageend}
                onChange={onChange}
                disabled={disabled || !quickroad}
              >
                <option value={mileageend}>{mileageend}</option>
                <option value={mileagestart}>{mileagestart}</option>
              </select>
            </div>
            <div
              className={
                parking
                  ? parkingchecked
                    ? "settings-field"
                    : "settings-field error"
                  : "settings-field zone-disabled"
              }
            >
              <label>{i18next.t("garage")}</label>
              <span className="settings-pk-from">{i18next.t("de")}</span>
              <select
                className={cx("settings-input", {
                  selectIsdesabled: disabled || !parking,
                })}
                name="parkingmileagestart"
                value={parkingmileagestart}
                onChange={onChange}
                disabled={disabled || !parking}
              >
                <option value={mileagestart}>{mileagestart}</option>
                <option value={mileageend}>{mileageend}</option>
              </select>
              <span className="settings-pk-to">{i18next.t("vers")}</span>
              <select
                className={cx("settings-input", {
                  selectIsdesabled: disabled || !parking,
                })}
                name="parkingmileageend"
                value={parkingmileageend}
                onChange={onChange}
                disabled={disabled || !parking}
              >
                <option value={mileageend}>{mileageend}</option>
                <option value={mileagestart}>{mileagestart}</option>
              </select>
            </div>
          </div>
          {authorization && !disabled && (
            <BtnGrid
              onSubmit={onSubmit}
              error={true}
              text={i18next.t("enregistrer")}
            />
          )}
        </BoxGrid>
      </li>
      <li className="settings ">
        <BoxGrid title="ZONES" classNames="boderShadow ">
          <div className="settings-field">
            <label>{i18next.t("bau")}</label>{" "}
            {bau && (
              <span className="recognize">
                <span className=" icon-check-green" />
              </span>
            )}
          </div>
          <div className="settings-field">
            <label>{i18next.t("trottoir")}</label>{" "}
            {sw && (
              <span className="recognize">
                <span className=" icon-check-green" />
              </span>
            )}
          </div>
          <div className="settings-field">
            <label>{i18next.t("voie lente")} </label>{" "}
            {slowroad && (
              <span className="recognize">
                <span className=" icon-check-green" />
              </span>
            )}
          </div>
          <div className="settings-field">
            <label>{i18next.t("voie rapide")} </label>{" "}
            {quickroad && (
              <span className="recognize">
                <span className=" icon-check-green" />
              </span>
            )}
          </div>
          <div className="settings-field">
            <label>{i18next.t("garage")} </label>{" "}
            {parking && (
              <span className="recognize">
                <span className=" icon-check-green" />
              </span>
            )}
          </div>
        </BoxGrid>
      </li>
    </div>
  );
};

// initialisation des props

Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  bauchecked?: any;
  swchecked?: any;
  slowroadchecked?: any;
  quickroadchecked?: any;
  parkingchecked?: any;
  disabled?: any;
  mileagestart?: any;
  name?: any;
  type?: any;
  length?: any;
  parking?: any;
  quickroad?: any;
  sectionsettings?: any;
  mileageend?: any;
  slowroad?: any;
  slowroadmileagestart?: any;
  swmileagestart?: any;
  swmileageend?: any;
  sw?: any;
  parkingmileagestart?: any;
  bau?: any;
  baumileagestart?: any;
  baumileageend?: any;
  onChange?: any;
  parkingmileageend?: any;
  slowroadmileageend?: any;
  quickroadmileagestart?: any;
  quickroadmileageend?: any;
  onSubmit?: any;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/system-section/component.tsx